module.exports = __webpack_public_path__ + "img/qr2.0ce47c32.png";